import { createSelector } from 'reselect';

const getState = ({ languages }) => languages;

export const getLanguages = createSelector(getState, ({ data }) => data);

export const isFetching = createSelector(getState, state => state.isFetching);
